import React, { useState } from 'react';
import '../styles/GeneralStyles.css';
import iconRadio1 from '../assets/ring-vector-1.svg'
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg'
import imgVVS2 from '../assets/tressor__claridad_vvs2.webp'
import imgVS1 from '../assets/pureza-tressor-sketches-08.webp'
import imgVS2 from '../assets/pureza-tressor-sketches-09.webp'
import imgSI1 from '../assets/pureza-tressor-sketches-10.webp' 
import portadaClarity from '../assets/portadas/Portada-05-Pureza.webp'


const Step4 = ({ nextStep, prevStep, handleInputChange, formData, isSubmitting }) => {
  const [selectedOption, setSelectedOption] = useState(formData?.clarity || null);

  const options = [
    {
      id: 1,
      icon: iconRadio1,
      text: "VVS2",
      value1: 3225,
      value2: 8600,
      value3: 9675,
      value4: 30100,
      title: "Claridad VVS2",
      description: "Sin inclusiones visibles",
      image: imgVVS2,
    },
    {
      id: 2,
      icon: iconRadio1,
      text: "VS1",
      value1: 2150,
      value2: 6450,
      value3: 7310,
      value4: 19350,
      title: "Claridad VS1",
      description: "Detalles casi imperceptibles",
      image: imgVS1
    },
    {
      id: 3,
      icon: iconRadio1,
      text: "VS2", 
      value1: 1075,
      value2: 4300,
      value3: 4945,
      value4: 10750,
      title: "Claridad VS2",
      description: "Pureza excelente y equilibrada",
      image: imgVS2
    },
    {
      id: 4,
      icon: iconRadio1,
      text: "SI1",
      value1: 0,
      value2: 2150,
      value3: 2580,
      value4: 7525,
      title: "Claridad SI1",
      description: "Belleza accesible con pequeñas inclusiones no perceptibles a simple vista",
      image: imgSI1
    }
  ];

  const handleOptionSelect = (option) => {
    const selectedCaratId = formData?.carats?.selectedId;
    const valueKey = `value${selectedCaratId}`;
    const finalValue = selectedCaratId ? option[valueKey] : option.value1;

    setSelectedOption(option);
    handleInputChange('clarity', {
      ...option,
      value: finalValue
    });
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
            <h2 className='heading-style-h3 text-align-center'>Escoge la Pureza del Diamante.</h2>
            <p className='text-size-medium text-color-grey'>También conocido como “Clarity”, esta característica nos dice la cantidad de inclusiones que el diamante tiene por dentro. Recomendamos no bajar de SI1 ya que en un grado menor las impurezas podrían ser apreciables a simple vista.</p>
            <div className='container-radio-options'>
            <div className='wrapp-radio-options'>
            <div className="radio-options">
              {options.map((option) => (
                <label key={option.id} className="radio-label">
                  <input
                    type="radio"
                    name="clarity"
                    checked={selectedOption?.id === option.id}
                    onChange={() => handleOptionSelect(option)}
                  />
                  <img src={option.icon} className="radio-icon" alt="ring icon" />
                  <span className="radio-text">{option.text}</span>
                </label>
              ))}
            </div>
            </div>
            </div>
          </div>
          
          <div className="wrapp-btns">
            <button className="button-prev" onClick={prevStep}>
              <img src={iconArrowLeft} alt="arrow left" />
              Volver
            </button>
            <button 
              className="button" 
              onClick={nextStep}
              disabled={!selectedOption}
            >
              Siguiente
              <img src={iconArrowRight} alt="arrow right" />
            </button>
          </div>
        </div>
        
        <div className="preview-column">
          {selectedOption ? (
            <>
              <div className='imgOptionSelected'>
                <img 
                  src={selectedOption.image} 
                  alt={selectedOption.text}
                  className="ring-preview-image"
                />
              </div>
              <div className='textOptionSelected'>
                <h3 className="text-align-left">{selectedOption.title}</h3>
                <p className="text-style-medium text-align-left">
                  {selectedOption.description}
                </p>
              </div>
            </>
          ) : (
            <div className="no-selection-message">
              <img src={portadaClarity} className='imgPreviewNoText' alt="Preview anillo" />
              <div className='wrappNoSelectText'>
                <p className='heading-style-h4 text-weight-bold text-color-white'>Claridad</p>
                <p className='text-size-large text-color-white'>Por favor selecciona la claridad</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step4;